class ProductRecommendationsCustom extends HTMLElement {
    observer = undefined;

    constructor() {
        super();
    }

    connectedCallback() {
        const cartProductIds = this.dataset.cartProductIds?.split(',');
        if (cartProductIds && cartProductIds.length > 0) {
            this.initializeRecommendations(cartProductIds);
        }
    }

    initializeRecommendations(cartProductIds) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
            (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                this.loadRecommendations(cartProductIds);
            },
            { rootMargin: '0px 0px 400px 0px' },
        );
        this.observer.observe(this);
    }

    async loadRecommendations(cartProductIds) {
        // If the fetch has already been done, do not reset the content
        if (this.querySelector('ul.product-grid')) {
            return;
        }

        // Reset the content for avoid duplication and start the first fetch
        this.innerHTML = '';

        const productsToShow = parseInt(this.dataset.productsToShow, 10); // Total products to shows
        const numCartProducts = cartProductIds.length;

        // Calculate how many products to show for each product in the cart
        const productsPerProduct = Math.floor(productsToShow / numCartProducts);
        const remainingProducts = productsToShow % numCartProducts;

        let ulElement = null;
        let headingElement = null;

        try {
            // Loop throught product id's in the cart
            for (let i = 0; i < numCartProducts && i < productsToShow; i++) {
                const productId = cartProductIds[i];
                const limit = i < remainingProducts ? productsPerProduct + 1 : productsPerProduct; // If there are remaining products, load one product more for the first "remainingsProducts" products in the cart

                const url = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}&limit=${limit}`;

                const response = await fetch(url);
                const text = await response.text();

                const html = document.createElement('div');
                html.innerHTML = text;

                // If the ul hasn't been crated yet, let's create it
                if (!ulElement) {
                    ulElement = html.querySelector('ul.product-grid');
                    if (ulElement) {
                        this.appendChild(ulElement);
                    }
                }

                if (!headingElement) {
                    headingElement = html.querySelector('.related-products__heading');
                    if (headingElement) {
                        this.prepend(headingElement);
                    }
                }

                // Find the products and add them to the existing ul
                const relatedProducts = html.querySelectorAll('.grid__item');

                relatedProducts.forEach((product) => {
                    ulElement.appendChild(product);
                });
            }
        } catch (e) {
            console.error(`Errore nel caricamento dei prodotti correlati:`, e);
        }

        if (this.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
        }
    }
}

customElements.define('product-recommendations-custom', ProductRecommendationsCustom);
